import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import styled, { css } from 'styled-components';
import {
  standardColours,
  brandColours,
  standardTransition,
} from '../../styles';
import { Svg } from './Svg';
import arrowIcon from '../../images/arrow-icon.inline.svg';

const StyledButton = styled.button`
  position: absolute;
  top: 50%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 75px;
  background-color: ${brandColours.primary};
  border: none;
  border-radius: 50%;
  transform: translateY(-50%);
  transition: ${standardTransition('background-color')};

  svg {
    height: 22px;
    width: 22px;
    fill: ${standardColours.white};
  }

  &:hover {
    background-color: ${brandColours.secondary};
  }

  ${({ direction }) => {
    if (direction === 'prev') {
      return css`
        left: 0;

        svg {
          transform: rotate(180deg);
        }
      `;
    } else if (direction === 'next') {
      return css`
        right: 0;
      `;
    }
  }}
`;

export const Slider = ({ children, ...props }) => (
  <Swiper {...props}>
    {children.map((child, id) => (
      <SwiperSlide key={id}>{child}</SwiperSlide>
    ))}
  </Swiper>
);

export const PrevButton = ({ ...props }) => (
  <StyledButton aria-label="Previous" direction="prev" {...props}>
    <Svg image={arrowIcon} />
  </StyledButton>
);

export const NextButton = ({ ...props }) => (
  <StyledButton aria-label="Next" direction="next" {...props}>
    <Svg image={arrowIcon} />
  </StyledButton>
);
